import gql from 'graphql-tag'

export default gql`
	query getKitchenTimeSlots {
		cashAssist {
			getAppConfig {
				cashRegisterGlobal {
					kitchenTimeSlots(onlyActive: true) {
						timeSlotCode
						name
					}
				}
			}
		}
	}
`
